(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loyalty-page"] && !Shopify.designMode) return;
  try {
    
  /* ── Loyalty Page Controller ── */

  const loyaltyConfig = window.theme.loyalty || {};

  const HEADER_OFFSET = loyaltyConfig.headerOffset || 70;

  const NAV_LANDING_GAP = 10;

  const SCROLL_LOCK_MS = 900;

  /* ── Tab switching (guest view) ── */

  function initLoyaltyTabs() {
    const tabNav = document.querySelector('[data-loyalty-nav="tabs"]');
    if (!tabNav) return;

    const tabs = tabNav.querySelectorAll('[data-loyalty-tab]');
    const panels = document.querySelectorAll('[data-loyalty-panel]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('data-loyalty-tab');

        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(panel => {
          const panelId = panel.getAttribute('data-loyalty-panel');
          if (panelId === targetId) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });

        pullTabNavToTop(tabNav);
      });
    });
  }

  function pullTabNavToTop(tabNav) {
    if (!tabNav.classList.contains('is-fixed')) return;

    const anchor = tabNav.previousElementSibling;
    if (!anchor) return;

    const header = document.querySelector('#HeaderWrapper');
    const offset = header ? header.getBoundingClientRect().height : 0;
    const top = anchor.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  /* ── Smooth scroll (member view) ── */

  let scrollLockUntil = 0;

  function getNavLanding(nav, goingUp) {
    const header = goingUp ? document.querySelector('#HeaderWrapper') : null;
    return (header ? header.offsetHeight : 0) + nav.offsetHeight + NAV_LANDING_GAP;
  }

  function initLoyaltyScroll() {
    const scrollNav = document.querySelector('[data-loyalty-nav="scroll"]');
    if (!scrollNav) return;

    const links = scrollNav.querySelectorAll('[data-loyalty-scroll]');

    links.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('data-loyalty-scroll');
        const target = document.getElementById(targetId);
        if (!target) return;

        links.forEach(other => {
          other.classList.toggle('is-active', other === link);
        });
        scrollLockUntil = Date.now() + SCROLL_LOCK_MS;

        const rawTop = target.getBoundingClientRect().top + window.scrollY;
        let top = rawTop - getNavLanding(scrollNav, false);
        if (top < window.scrollY) top = rawTop - getNavLanding(scrollNav, true);

        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });
  }

  /* ── Scroll spy ── */

  function initLoyaltyScrollSpy() {
    const scrollNav = document.querySelector('[data-loyalty-nav="scroll"]');
    if (!scrollNav) return;

    const links = Array.prototype.slice.call(scrollNav.querySelectorAll('[data-loyalty-scroll]'));
    const sections = links
      .map(link => document.getElementById(link.getAttribute('data-loyalty-scroll')))
      .filter(Boolean);

    if (!sections.length) return;

    let ticking = false;

    function update() {
      ticking = false;

      if (Date.now() < scrollLockUntil) return;

      const barBottom = Math.max(scrollNav.getBoundingClientRect().bottom, HEADER_OFFSET);
      const line = barBottom + NAV_LANDING_GAP + 1;
      let currentId = sections[0].id;

      sections.forEach(section => {
        if (section.getBoundingClientRect().top <= line) currentId = section.id;
      });

      links.forEach(link => {
        link.classList.toggle('is-active', link.getAttribute('data-loyalty-scroll') === currentId);
      });
    }

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    ['wheel', 'touchstart', 'keydown'].forEach(type => {
      window.addEventListener(type, () => { scrollLockUntil = 0; }, { passive: true });
    });

    window.addEventListener('resize', update);
    update();
  }

  /* ── History table ── */

  function relabelHistoryHeaders() {
    const table = document.querySelector('[data-lion-history-table] .lion-history-table');
    if (!table) {
      setTimeout(relabelHistoryHeaders, 400);
      return;
    }

    const headers = table.querySelectorAll('th');
    if (headers.length < 5) return;

    headers[2].textContent = 'Type';
  }

  /* ── FAQ accordion ── */

  const FAQ_TRANSITION_MS = 300;

  function expandFaqPanel(panel) {
    panel.classList.add('is-open');
    panel.style.height = panel.scrollHeight + 'px';

    let settled = false;

    function settle() {
      if (settled) return;
      settled = true;
      panel.removeEventListener('transitionend', onEnd);
      if (panel.classList.contains('is-open')) panel.style.height = 'auto';
    }

    function onEnd(event) {
      if (event.propertyName === 'height' && event.target === panel) settle();
    }

    panel.addEventListener('transitionend', onEnd);
    setTimeout(settle, FAQ_TRANSITION_MS + 50);
  }

  function collapseFaqPanel(panel) {
    panel.style.height = panel.scrollHeight + 'px';
    void panel.offsetHeight;
    panel.classList.remove('is-open');
    panel.style.height = '0px';
  }

  function initLoyaltyFaq() {
    const faqContainer = document.querySelector('[data-loyalty-faq]');
    if (!faqContainer) return;

    /* ── questions ── */
    faqContainer.querySelectorAll('[data-loyalty-faq-question]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const answer = trigger.parentElement.querySelector('[data-loyalty-faq-answer]');
        if (!answer) return;

        const isOpen = answer.classList.contains('is-open');
        if (isOpen) {
          collapseFaqPanel(answer);
        } else {
          expandFaqPanel(answer);
        }
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    /* ── categories, one at a time ── */
    faqContainer.querySelectorAll('[data-loyalty-faq-category]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const content = trigger.parentElement.querySelector('[data-loyalty-faq-content]');
        if (!content) return;

        const isOpen = content.classList.contains('is-open');

        faqContainer.querySelectorAll('[data-loyalty-faq-content].is-open').forEach(open => {
          collapseFaqPanel(open);
          const openTrigger = open.parentElement.querySelector('[data-loyalty-faq-category]');
          if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          expandFaqPanel(content);
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── Hero video ── */

  let heroTierKey = null;
  let heroTierDecided = false;
  const heroSourceAppliers = [];

  function initLoyaltyHeroVideo() {
    document.querySelectorAll('[data-loyalty-hero-video]').forEach(setUpHeroVideo);
  }

  function resolveHeroSrc(video, isDesktop) {
    if (heroTierKey) {
      const tierVideo = (loyaltyConfig.tierVideos || {})[heroTierKey];
      const tierSrc = tierVideo && tierVideo[isDesktop ? 'desktop' : 'mobile'];
      if (tierSrc) return tierSrc;
    }

    if (video.hasAttribute('data-defer-src') && !heroTierDecided) return null;

    return video.getAttribute(isDesktop ? 'data-src-desktop' : 'data-src-mobile');
  }

  function setUpHeroVideo(video) {
    const query = window.matchMedia('(min-width: 769px)');

    function applySource() {
      const src = resolveHeroSrc(video, query.matches);
      if (!src || video.getAttribute('src') === src) return;

      video.src = src;
      const played = video.play();
      if (played && played.catch) played.catch(function () {});
    }

    heroSourceAppliers.push(applySource);

    if (query.addEventListener) {
      query.addEventListener('change', applySource);
    } else if (query.addListener) {
      query.addListener(applySource);
    }

    applySource();

    const loopDelay = parseInt(video.getAttribute('data-loop-delay'), 10);
    if (!loopDelay || loopDelay < 0) return;

    video.removeAttribute('loop');
    video.loop = false;

    const fadeDuration = Math.min(400, Math.round(loopDelay / 2));
    video.style.setProperty('--loyaltyHeroFade', fadeDuration + 'ms');

    video.addEventListener('ended', function () {
      video.classList.add('is-loop-fading');

      setTimeout(function () {
        video.currentTime = 0;
        const replayed = video.play();
        if (replayed && replayed.catch) replayed.catch(function () {});
        video.classList.remove('is-loop-fading');
      }, loopDelay);
    });
  }

  /* ── Member tier ── */

  const TIER_TIMEOUT_MS = 3000;
  const TIER_POLL_MS = 200;

  function alignTierHeading(heading) {
    const context = document.createElement('canvas').getContext('2d');
    if (!context) return;

    const style = window.getComputedStyle(heading);
    const size = 100;
    context.font = style.fontWeight + ' ' + size + 'px ' + style.fontFamily;
    const metrics = context.measureText(heading.textContent.trim().toLowerCase());

    if (!metrics.fontBoundingBoxAscent) return;

    const ascent = metrics.fontBoundingBoxAscent / size;
    const descent = metrics.fontBoundingBoxDescent / size;
    const baselineFromBottom = descent - (ascent + descent - 1) / 2;

    heading.style.setProperty('--tierInkLeft', (metrics.actualBoundingBoxLeft / size).toFixed(4) + 'em');
    heading.style.setProperty('--tierInkBottom', (-baselineFromBottom).toFixed(4) + 'em');
  }

  function initLoyaltyTier() {
    const heading = document.querySelector('[data-loyalty-tier-name]');
    const deferredHero = document.querySelector('[data-loyalty-hero-video][data-defer-src]');

    if (!heading && !deferredHero) return;

    const deadline = Date.now() + TIER_TIMEOUT_MS;

    function settle(tierName) {
      heroTierKey = tierName ? tierName.trim().toLowerCase() : null;
      heroTierDecided = true;

      if (heading) {
        if (tierName) heading.textContent = tierName;
        alignTierHeading(heading);
        heading.classList.remove('is-resolving');
      }

      heroSourceAppliers.forEach(apply => apply());
    }

    function poll() {
      const nameEl = document.querySelector('.lion-tier-progress__bar-section--current .lion-tier-progress__bar-section__tier-name');
      const name = nameEl ? nameEl.textContent.trim() : '';

      if (name) {
        settle(name);
      } else if (Date.now() >= deadline) {
        settle(null);
      } else {
        setTimeout(poll, TIER_POLL_MS);
      }
    }

    poll();
  }

  /* ── SDK modals ── */

  const MODAL_TIMEOUT_MS = 4000;
  const MODAL_BOOT_TIMEOUT_MS = 15000;
  const MODAL_POLL_MS = 100;
  const MODAL_WRAPPER = '.lion-modal-and-screen';

  function referralRuleCard() {
    return document.querySelector('.lion-rule-item--\\$referral');
  }

  function describeRuleCard(card) {
    if (!card) return null;
    const title = card.querySelector('.lion-rule-item__title');
    return {
      id: card.getAttribute('data-rule-id'),
      title: title ? title.textContent.trim() : ''
    };
  }

  function rewardArtwork(rewardId) {
    const card = document.querySelector('.lion-reward-item[data-reward-id="' + rewardId + '"]');
    if (!card) return null;

    const img = card.querySelector('img[src]');
    if (img) return 'url("' + img.src + '")';

    const icon = card.querySelector('.lion-reward-item__icon');
    const background = icon && window.getComputedStyle(icon).backgroundImage;
    return background && background !== 'none' ? background : null;
  }

  function rewardData(rewardId) {
    const card = document.querySelector('.lion-reward-item[data-reward-id="' + rewardId + '"]');
    const key = card && Object.keys(card).find(k => k.startsWith('__reactFiber$'));
    if (!key) return null;

    const stack = [card[key].child];
    while (stack.length) {
      const fiber = stack.pop();
      if (!fiber) continue;
      const reward = fiber.memoizedProps && fiber.memoizedProps.reward;
      if (reward && String(reward.id) === String(rewardId)) return reward;
      stack.push(fiber.sibling, fiber.child);
    }
    return null;
  }

  function addRewardTerms(wrapper, rewardId) {
    const box = wrapper.querySelector('.lion-redeem-reward-modal__confirm-box');
    const reward = box && rewardData(rewardId);
    if (!reward || !reward.description || box.querySelector('.loyalty-page__reward-terms')) return;

    const terms = document.createElement('div');
    terms.className = 'loyalty-page__reward-terms';
    terms.textContent = reward.description;
    box.insertBefore(terms, box.querySelector(':scope > .lion-redeem-reward-modal__button-container'));
  }

  function initClaimedRewardArtwork() {
    if (!document.getElementById('your-rewards')) return;

    const deadline = Date.now() + MODAL_BOOT_TIMEOUT_MS;

    function apply() {
      const rules = [];
      document.querySelectorAll('#loyaltylion .lion-reward-item[data-reward-id]').forEach(card => {
        const id = card.getAttribute('data-reward-id');
        const artwork = rewardArtwork(id);
        if (artwork) {
          rules.push('#loyaltylion .lion-claimed-reward-item[data-reward-id="' + id + '"] .lion-claimed-reward-item__icon { background-image: ' + artwork + '; }');
        }
      });

      const style = document.createElement('style');
      style.textContent = rules.join('\n');
      document.head.appendChild(style);
    }

    function poll() {
      if (document.querySelector('#loyaltylion .lion-reward-item[data-reward-id]')) {
        apply();
      } else if (Date.now() < deadline) {
        setTimeout(poll, TIER_POLL_MS);
      }
    }

    poll();
  }

  function warnOnModalShapeChange(wrapper, isReferral) {
    const required = isReferral
      ? ['.lion-referral-widget-modal', '.lion-referral-widget-modal__header',
         '.lion-referral-widget-main__share-link-container']
      : ['.lion-modal', '.lion-modal__header', '.lion-modal__title'];

    if (wrapper.querySelector('.lion-history-info-modal-content')) {
      required.push('.lion-history-info-modal-content__state-bubble', '.lion-reward-code');
    }

    const missing = required.filter(function (sel) { return !wrapper.querySelector(sel); });
    if (!wrapper.querySelector('[role="dialog"]')) missing.push('[role="dialog"]');

    if (missing.length) {
      console.warn(
        '[loyalty] The LoyaltyLion modal markup has changed. These selectors no longer ' +
        'match, so the popup will be partly or wholly unstyled: ' + missing.join(', ')
      );
    }
  }

  function trimTrailingQuestionMark(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let last = null;
    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue.trim()) last = walker.currentNode;
    }
    if (last) last.nodeValue = last.nodeValue.replace(/\s*\?\s*$/, '');
  }

  function onModalOpened(wrapper, rule) {
    const isReferral = !!wrapper.querySelector('.lion-referral-widget-modal');

    if (!rule && isReferral) rule = describeRuleCard(referralRuleCard());

    if (rule && rule.id) wrapper.setAttribute('data-loyalty-rule', rule.id);

    if (rule && rule.rewardId) {
      wrapper.setAttribute('data-loyalty-reward', rule.rewardId);
      const artwork = rewardArtwork(rule.rewardId);
      if (artwork) wrapper.style.setProperty('--loyaltyModalArt', artwork);
    }

    warnOnModalShapeChange(wrapper, isReferral);

    if (isReferral) {
      if (rule && rule.title) {
        const header = wrapper.querySelector('.lion-referral-widget-modal__header');
        if (header && header.textContent.trim() !== rule.title) header.textContent = rule.title;
      }

      const linkText = wrapper.querySelector('.lion-referral-widget-main__share-link-text');
      if (linkText) {
        const trimmed = linkText.textContent.trim().replace(/^or\s+/i, '');
        const sentence = trimmed && trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
        if (sentence && sentence !== linkText.textContent.trim()) linkText.textContent = sentence;
      }
    }

    const summary = wrapper.querySelector('.lion-redeem-reward-modal__confirm-summary');
    if (summary) trimTrailingQuestionMark(summary);

    if (rule && rule.rewardId) addRewardTerms(wrapper, rule.rewardId);

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    (function untilClosed() {
      if (document.querySelector(MODAL_WRAPPER)) {
        setTimeout(untilClosed, MODAL_POLL_MS);
        return;
      }
      document.body.style.overflow = previousOverflow;
    })();
  }

  function watchForModal(rule, timeoutMs) {
    const deadline = Date.now() + timeoutMs;

    (function poll() {
      const wrapper = document.querySelector(MODAL_WRAPPER);

      if (wrapper) {
        onModalOpened(wrapper, rule);
      } else if (Date.now() < deadline) {
        setTimeout(poll, MODAL_POLL_MS);
      }
    })();
  }

  function initLoyaltyModals() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      const ruleCard = e.target.closest('.lion-rule-item');
      if (ruleCard) {
        watchForModal(describeRuleCard(ruleCard), MODAL_TIMEOUT_MS);
        return;
      }

      const rewardCard = e.target.closest('.lion-reward-item, .lion-claimed-reward-item');
      if (rewardCard) {
        watchForModal({ rewardId: rewardCard.getAttribute('data-reward-id') }, MODAL_TIMEOUT_MS);
      }
    }, true);

    if (/[?&]ll_act=refer(&|$)/.test(window.location.search)) {
      watchForModal(null, MODAL_BOOT_TIMEOUT_MS);
    }
  }

  /* ── Points format ── */

  function formatPoints(value) {
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
  }

  const POINTS_SCOPE = '.loyalty-page, #lion-loyalty-panel-custom-css';

  function spaceThousands(node) {
    const parent = node.parentElement;
    if (node.nodeType !== Node.TEXT_NODE || !parent) return;
    if (/^(SCRIPT|STYLE|TEXTAREA)$/.test(parent.nodeName) || !parent.closest(POINTS_SCOPE)) return;
    const formatted = node.nodeValue.replace(/(\d),(?=\d{3}(?!\d))/g, '$1\u00a0');
    if (formatted !== node.nodeValue) node.nodeValue = formatted;
  }

  function spaceThousandsIn(root) {
    if (root.nodeType === Node.TEXT_NODE) return spaceThousands(root);
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (!root.closest(POINTS_SCOPE) && !root.querySelector(POINTS_SCOPE)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) spaceThousands(walker.currentNode);
  }

  function initPointsFormat() {
    if (!document.querySelector('.loyalty-page')) return;

    document.querySelectorAll(POINTS_SCOPE).forEach(spaceThousandsIn);
    new MutationObserver(mutations => {
      mutations.forEach(m => {
        if (m.type === 'characterData') spaceThousands(m.target);
        else m.addedNodes.forEach(spaceThousandsIn);
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  /* ── Tier progress info ── */

  function updateTierProgressInfo() {
    const descEl = document.querySelector('[data-tier-progress-desc]');
    if (!descEl) return;

    const currentPointsEl = document.querySelector('[data-lion-points="approved"]');
    const nextTierBoundEl = document.querySelector('.lion-tier-progress__bar-section--upcoming .lion-tier-progress__bar-section__tier-bound');
    const nextTierNameEl  = document.querySelector('.lion-tier-progress__bar-section--upcoming .lion-tier-progress__bar-section__tier-name');

    if (!currentPointsEl || !nextTierBoundEl) {
      if (!document.querySelector('.lion-tier-progress__bar-section--current')) setTimeout(updateTierProgressInfo, 400);
      return;
    }

    const currentPoints = parseInt(currentPointsEl.textContent.replace(/[^0-9]/g, ''), 10);
    const nextBound     = parseInt(nextTierBoundEl.textContent.replace(/[^0-9]/g, ''), 10);
    const nextName      = nextTierNameEl ? nextTierNameEl.textContent.trim() : '';
    const pointsNeeded  = nextBound - currentPoints;

    if (pointsNeeded <= 0) {
      descEl.textContent = nextName ? "You've reached " + nextName + "!" : "You've reached the next tier!";
    } else {
      descEl.textContent = "You're " + formatPoints(pointsNeeded) + " points away from next tier.";
    }
  }

  /* ── Sticky nav ── */

  function initStickyNav() {
    const nav = document.querySelector('[data-loyalty-nav]');
    if (!nav) return;

    const placeholder = document.createElement('div');
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.cssText = 'display:none;flex-shrink:0;';
    placeholder.style.marginTop = window.getComputedStyle(nav).marginTop;
    nav.parentNode.insertBefore(placeholder, nav);

    function getHeaderBottom() {
      const header = document.querySelector('#HeaderWrapper');
      if (!header) return 0;
      return Math.max(0, header.getBoundingClientRect().bottom);
    }

    function tick() {
      const headerBottom = getHeaderBottom();
      const isFixed = nav.classList.contains('is-fixed');

      if (!isFixed) {
        if (nav.getBoundingClientRect().top <= headerBottom) {
          placeholder.style.height = nav.offsetHeight + 'px';
          placeholder.style.display = 'block';
          nav.style.top = headerBottom + 'px';
          nav.classList.add('is-fixed');
        }
      } else {
        nav.style.top = headerBottom + 'px';
        if (placeholder.getBoundingClientRect().top > headerBottom) {
          nav.classList.remove('is-fixed');
          nav.style.top = '';
          placeholder.style.display = 'none';
        }
      }
    }

    const SETTLE_FRAMES = 5;
    const MAX_FRAMES = 90;

    let rafId = null;
    let lastHeaderBottom = null;
    let idleFrames = 0;
    let pumpedFrames = 0;

    function pump() {
      const headerBottom = Math.round(getHeaderBottom());
      tick();

      if (headerBottom === lastHeaderBottom) {
        idleFrames++;
      } else {
        idleFrames = 0;
        lastHeaderBottom = headerBottom;
      }

      pumpedFrames++;
      const keepGoing = idleFrames < SETTLE_FRAMES && pumpedFrames < MAX_FRAMES;
      rafId = keepGoing ? window.requestAnimationFrame(pump) : null;
    }

    function wake() {
      idleFrames = 0;
      pumpedFrames = 0;
      if (rafId === null) rafId = window.requestAnimationFrame(pump);
    }

    window.addEventListener('scroll', wake, { passive: true });
    window.addEventListener('resize', wake);
  }

  /* ── Member hero ── */
  function initMemberHeroTuck() {
    const hero = document.querySelector('.loyalty-page__member-hero');
    const header = document.querySelector('#HeaderWrapper');
    if (!hero || !header) return;

    function measure() {
      hero.style.setProperty('--loyaltyHeaderH', header.getBoundingClientRect().height + 'px');
    }

    measure();
    window.addEventListener('resize', measure);
  }

  /* ── Init ── */

  initMemberHeroTuck();
  initLoyaltyTabs();
  initLoyaltyHeroVideo();
  initLoyaltyTier();
  initLoyaltyScroll();
  initLoyaltyScrollSpy();
  initStickyNav();
  initLoyaltyFaq();
  initLoyaltyModals();
  initClaimedRewardArtwork();
  initPointsFormat();
  updateTierProgressInfo();
  relabelHistoryHeaders();

  } catch(e) { console.error(e); }
})();
})();
